module.exports = __webpack_public_path__ + "img/eng.e8610538.svg";